import { render, staticRenderFns } from "./dealFlow.vue?vue&type=template&id=6a2d37d8&"
import script from "./dealFlow.vue?vue&type=script&lang=js&"
export * from "./dealFlow.vue?vue&type=script&lang=js&"
import style0 from "./dealFlow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports